module.exports = __webpack_public_path__ + "static/media/nunito_semibold.74a099b9.ttf";